import React from 'react';
import LnIcon from '../LnIcon';
import classes from './DragHandle.module.scss';

/**
 * The grip for a sortable item. Spread dnd-kit's `attributes` and `listeners` onto this
 * button itself, not onto a wrapper: the button is the one focusable control, and a
 * wrapper carrying role="button" and tabIndex would nest one button inside another and
 * add a second tab stop that does nothing.
 */
export function DragHandle(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {

    const { className, ...rest } = props;

    return (
      <button type="button" {...rest} className={`${classes.handle} ${className ?? ""}`} >
        <LnIcon name="draghandle" className='icon-small' />
      </button>
    )
}
